module.exports = __webpack_public_path__ + "img/IMG_3551-1.2f9af29d.jpg";